import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPollSettingsAction } from "../actions";
import {
  getLoading,
  getPolls,
  getVisualizationTypeList,
  getPollTypes,
  getModes,
  getProcessList,
  getOnaTypeList,
  getPositionList,
  getEmployeeList,
} from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { getFiltersIsLoading } from "@icarius-common/filtersDialog/selectors";
import { importIcariusFile, exportIcariusFile } from "@icarius-utils/exportImportIcarius";

const usePollSettings = () => {

  const [createPollIsOpen, setCreatePollIsOpen] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const [isImport, setIsImport] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPollSettingsAction());
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch])

  const handleOpenDuplicationDialog = (data) => {
    setDuplicateData(data);
    setIsImport(false);
  }

  const handleCloseDuplicationDialog = () => {
    setDuplicateData(null);
    setIsImport(false);
  }

  const importPoll = () => {
    importIcariusFile(dispatch, (data) => {
      setIsImport(true);
      setDuplicateData(data);
    });
  }

  const exportPoll = (poll) => {
    exportIcariusFile(dispatch, poll, poll.name);
  }

  const visualizationTypeList = useSelector(getVisualizationTypeList);
  const polls = useSelector(getPolls);
  const pollTypes = useSelector(getPollTypes);
  const modes = useSelector(getModes);
  const processList = useSelector(getProcessList);
  const isLoadingLocal = useSelector(getLoading);
  const filtersIsLoading = useSelector(getFiltersIsLoading);
  const isLoading = isLoadingLocal || filtersIsLoading;
  const onaTypeList = useSelector(getOnaTypeList);
  const positionList = useSelector(getPositionList);
  const employeeList = useSelector(getEmployeeList);

  return {
    isLoading,
    polls,
    visualizationTypeList,
    modes,
    processList,
    pollTypes,
    onaTypeList,
    positionList,
    createPollIsOpen,
    duplicateData,
    isImport,
    employeeList,
    setCreatePollIsOpen,
    handleOpenDuplicationDialog,
    handleCloseDuplicationDialog,
    exportPoll,
    importPoll,
  }
}

export default usePollSettings;